export function track (data: Record<string, unknown>) {
  if (!window.dataLayer) window.dataLayer = []
  window.dataLayer.push(data)
}
